exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.primary .v-stepper__step .v-stepper__label{\n  color:#fff !important;\n}\n.primary .v-stepper__step--active .v-stepper__label{\n  font-weight:700;\n}\n.v-stepper__step__step.primary{\n  background-color:rgba(0,0,0,.38) !important;\n  border-color:rgba(0,0,0,.38) !important;\n}\n.text-field-right input{\n  text-align:right;\n}\n", ""]);

// exports
